import { render, staticRenderFns } from "./r-item-state-notice.vue?vue&type=template&id=5c6248dc"
import script from "./r-item-state-notice.vue?vue&type=script&lang=js"
export * from "./r-item-state-notice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c6248dc')) {
      api.createRecord('5c6248dc', component.options)
    } else {
      api.reload('5c6248dc', component.options)
    }
    module.hot.accept("./r-item-state-notice.vue?vue&type=template&id=5c6248dc", function () {
      api.rerender('5c6248dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-state-notice.vue"
export default component.exports